export default {"src":"/_next/static/media/ArcTopLeftWhite.54d241e8.svg","height":20,"width":14,"blurWidth":0,"blurHeight":0};